import Vue from 'vue'
import worker from './worker'

const maxReconnectCount = 3 // 每轮计时重连次数
const reconnectInterval = 3 * 1000 // 每轮计时重连间隔
const LoopDuration = 15 * 1000
let reconnectCount = 0 // 当前轮计时重连次数
let connectStatus = 'success' // 'close' // 当前连接状态

const onNewMessage = (socket, store) => {
  socket.io.emit('new_message_count', (res) => {
    if (res?.code === 200) {
      store.commit('setMessageNotReadTotal', res?.data || 0)
    }
  })

  socket.io.on('new_room', () => {
    store.commit(
      'setMessageNotReadTotal',
      store.state.messageNotReadTotal + 1
    )
  })
}
const socketInitFn = ({
  ctx,
  token,
  storeId
  // adminId
}) => {
  if (!token && !ctx.app.$cookies.get('user-token')) {
    return false
  }
  const Sys = {}
  const ua = navigator.userAgent.toLowerCase()
  let s
  let osVersion
  let versionName

  /* eslint-disable */
  (s = ua.match(/msie ([\d.]+)/)) ? Sys.ie = s[1] :
    (s = ua.match(/firefox\/([\d.]+)/)) ? Sys.firefox = s[1] :
      (s = ua.match(/chrome\/([\d.]+)/)) ? Sys.chrome = s[1] :
        (s = ua.match(/opera.([\d.]+)/)) ? Sys.opera = s[1] :
          (s = ua.match(/version\/([\d.]+).*safari/)) ? Sys.safari = s[1] : 0
  if (Sys.ie) { versionName = 'IE'; osVersion = Sys.ie };
  if (Sys.firefox) { versionName = 'Firefox'; osVersion = Sys.firefox };
  if (Sys.chrome) { versionName = 'Chrome'; osVersion = Sys.chrome }
  if (Sys.opera) { versionName = 'Opera'; osVersion = Sys.opera }
  if (Sys.safari) { versionName = 'Safari'; osVersion = Sys.safari }

  const socket = {
    io: ctx.app.$nuxtSocket({
      transports: ['websocket'],
      withCredentials: true,
      query: {
        token: token && storeId ? token : ctx.app.$cookies.get('user-token'), 
        type: token && storeId ? '3' : '2'
      },
    })
  }
  console.log("🚀 ~ ctx:", ctx)

  onNewMessage(socket, ctx.store)

  const socketReconnect = (io) => {
    console.info("开始重连", reconnectCount)

    if(
      reconnectCount >= maxReconnectCount
        || ['reconnecting', 'success'].includes(connectStatus)
    ) {
      console.info("正在重连，或超出本轮最大重连数：", reconnectCount, connectStatus)
      return
    }
    reconnectCount ++
    
    socket.io.disconnect()
    setTimeout(() => { 
      io.connect()

      onNewMessage(socket, ctx.store)
    }, reconnectInterval)
  }

  // 链接异常
  socket.io.on('connect_error', (res) => {
    // 商家,  跳转登陆重新获取token
    if(!token && !ctx.app.$cookies.get('user-token')) {
      if(ctx.route.path !== '/login') {
        ctx.app.router.push('/login')
      }
    } else {
      // 运营测,  提示链接失败
      console.info('socket.io connect_error', res)

      // 重新链接
      socketReconnect(socket.io)
    }
  })

  // 链接中断
  socket.io.on('disconnect', (e) => {
    connectStatus = 'disconnect'
    
    console.error("🚀 ~ socket.io.on ~ e:", e, connectStatus)
    socketReconnect(socket.io)
  })

  socket.io.on('reconnecting', (res) => {
    connectStatus = 'reconnecting'

    console.info("🚀 ~ socket.io.on ~ reconnecting:", res, connectStatus)
  })
  // 重连失败
  socket.io.on('reconnect_failed', (res) => {
    connectStatus = 'reconnect_failed'

    console.info("🚀 ~ socket.io.on ~ res:", res, connectStatus)

    socketReconnect(socket.io)
  })
  // 重连成功
  socket.io.on('reconnect', (res) => {
    connectStatus = 'success'

    console.info("🚀 ~ socket.io.on ~ reconnect:", res, connectStatus)
  })

  /**
   * 发送设备信息
   */
  socket.io.emit('device', {'client_version': versionName}, (res) => { })

  return socket
}

export default async(ctx) => {
  let socket = null

  const initSocket = (type = 'init') => {
    if(socket && type === 'init') {
      return console.info('socket has init ok.')
    }

    if(type === 'refresh') {
      socket && socket.io.disconnect()
      socket = null
    }

    const {
      token,
      store_id: storeId
      // admin_id: adminId
    } = ctx.route.query

    socket = socketInitFn({
      ctx,
      token,
      storeId
    })
    
    if(!socket) {
      return console.error('Socket init error!!!')
    }

    Vue.prototype.$socketInstance = socket
    worker.postMessage({
      command: 'interval:start',
      data: {
        interval: LoopDuration,
        id: 'message_worker_interval_task' 
      }
    })
  
    worker.onmessage = (e) => {
      if(e.data.id === 'message_worker_interval_task') {
        try {
          socket.io.emit('system_message', {
            event_name: 'heartbeat',
            event_data: Date.now()
          })
          
          reconnectCount = 0
        } catch(e) {
          console.error("socket.io 已被回收:", e)
          socketInitFn({
            ctx,
            token,
            storeId
          })
        }
      }
    }
  }
  // 排除此母版页
  if (ctx.nuxtState.layout !== 'printface') {
    initSocket()
  }


  Vue.prototype.$initSocket = initSocket
  Vue.prototype.$discountSocket = () => {
    if(socket) {
      socket && socket.io.disconnect()
      socket = null
    }
  }
}
